export const crmRoutes = [
  {
    path: '/crm/mail-reply-manager',
    component: () => import('@/views/modules/crm/mail-reply/mail-reply-manager'),
    meta: { name: '邮件回复', keepAlive: true, permission: 'ticket:view', modal: '客服' }
  },
  {
    path: '/crm/mail-template',
    component: () => import('@/views/modules/crm/mail-template/mail-template'),
    meta: { name: '邮件模板', keepAlive: true, permission: 'mailTemplate:view', modal: '客服' }
  },
  {
    path: '/crm/send-rule',
    component: () => import('@/views/modules/crm/send-rule/send-rule'),
    meta: { name: '关怀邮件', keepAlive: true, permission: 'requestRule:view', modal: '客服' }
  },
  {
    name: 'send-rule-add',
    path: '/crm/send-rule-add/:state',
    component: () => import('@/views/modules/crm/send-rule/send-rule-add'),
    meta: { name: '新增关怀邮件', keepAlive: false, permission: 'requestRule:add', modal: '客服' }
  },
  {
    name: 'send-rule-edit',
    path: '/crm/send-rule-edit/:state/:id',
    component: () => import('@/views/modules/crm/send-rule/send-rule-edit'),
    meta: { name: '编辑关怀邮件', keepAlive: false, permission: 'requestRule:edit', modal: '客服' }
  },
  {
    name: 'send-rule-view',
    path: '/crm/send-rule-view/:state/:id',
    component: () => import('@/views/modules/crm/send-rule/send-rule-view'),
    meta: { name: '查看关怀邮件', keepAlive: false, permission: 'requestRule:view', modal: '客服' }
  },
  {
    path: '/crm/send-record',
    component: () => import('@/views/modules/crm/send-record/send-record'),
    meta: { name: '请求记录', keepAlive: true, permission: 'requestRecord:view', modal: '客服' }
  },
  {
    path: '/crm/tag-manager',
    component: () => import('@/views/modules/crm/tag-manager/tag-manager'),
    meta: { name: '标签管理', keepAlive: true, permission: 'tag:view', modal: '客服' }
  },
  {
    path: '/crm/off-site-mailbox',
    component: () => import('@/views/modules/crm/off-site-mailbox/off-site-mailbox'),
    meta: { name: '站外邮箱', keepAlive: true, permission: 'tag:view', modal: '客服' }
  }
];
